<script lang="ts">
  import {
    getProductXScrollListStyle,
    styleToString,
  } from "@shared/common/node/style";
  import type {
    IProductXScrollListNode,
    PartialNode,
  } from "@shared/common/node/type";
  import type { IProductListData } from "@shared/common/types/data-source";
  import { onMount } from "svelte";
  import { getStore } from "../../context";
  import ProductItem from "./product-item.svelte";

  const { dataMap } = getStore();

  export let node: PartialNode<IProductXScrollListNode>;

  $: productsFromDataMap = node.dataAlias
    ? ($dataMap[node.dataAlias] as IProductListData | undefined)?.data
    : undefined;

  $: productsData = productsFromDataMap?.items || node.initialData || [];

  let scrollElement: HTMLDivElement;

  onMount(() => {
    if (!scrollElement) {
      return;
    }

    const onWheel = (e: WheelEvent) => {
      const maxScrollLeft =
        scrollElement.scrollWidth - scrollElement.clientWidth;

      // 좌측 끝(스크롤 처음)에서 위로 스크롤 시, 또는 우측 끝(스크롤 마지막)에서 아래로 스크롤 시는 원래대로 동작하게 함
      if (
        (e.deltaY < 0 && scrollElement.scrollLeft <= 0) ||
        (e.deltaY > 0 && scrollElement.scrollLeft >= maxScrollLeft)
      ) {
        return; // 기본 세로 스크롤 동작 허용
      }

      // 그 외의 경우에는 세로 스크롤을 가로 스크롤로 변환
      e.preventDefault();
      scrollElement.scrollLeft += e.deltaY + e.deltaX;
    };

    scrollElement.addEventListener("wheel", onWheel, { passive: false });

    return () => {
      scrollElement.removeEventListener("wheel", onWheel);
    };
  });
</script>

<div
  style={`${styleToString(getProductXScrollListStyle(node))} z-index: 0;`}
  class="aspect-ratio"
>
  {#if productsData && productsData.length > 0}
    <div class="product-x-scroll-list-container" bind:this={scrollElement}>
      {#each productsData as product}
        <ProductItem {product} {node} />
      {/each}
    </div>
  {:else}
    <div>
      <p>상품이 없습니다.</p>
    </div>
  {/if}
</div>

<style>
  .aspect-ratio::before {
    content: "";
    padding-top: var(--cb-before-padding-top);
    float: left;
  }

  .aspect-ratio::after {
    clear: left;
    content: " ";
    display: table;
  }

  .product-x-scroll-list-container {
    display: flex;
    gap: 16px;
    overflow-x: auto;
    padding: 16px 20px;
  }
</style>
